import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Flex from "../../../../../components/Flex";
import CustomTabs from "../../../../../components/app/CustomTabs";
import { roleFilter } from "../../../../../utils/utils";

const FaxLayout = () => {
  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "fax" ? "" : (currentTab as string);
  });
  const navigate = useNavigate();

  return (
    <>
      {/* Tabs and Filter Bar Combined */}
      <Flex
        alignItems={"center"}
        width={"100%"}
        borderBottom={"1px solid rgb(229, 224, 224)"}
      >
        <Flex width={"100%"}>
          <CustomTabs
            tabsData={roleFilter({
              list: [
                {
                  value: "",
                  label: "Incoming Fax",
                },
                {
                  value: "outgoing-fax",
                  label: "Outgoing Fax",
                },
                // {
                //   value: "fax-folder",
                //   label: "Fax Folders",
                // },
              ],
              compWith: {},
            })}
            value={activeTab}
            onChange={(v) => {
              setActiveTab(v);
              navigate(v);
            }}
          />
        </Flex>
        <Flex width={"100%"} justifyContent={"flex-end"}>
          {/* {renderFilters()} */}
        </Flex>
      </Flex>

      <Outlet
        context={{
          activeTab,
        }}
      />
    </>
  );
};

export default FaxLayout;
